export default __webpack_public_path__ + "static/media/mitigation-exposed-framing-drying-2.d5513c30.jpg";